var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestricted16 = function SvgRestricted16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M.5.5h19v19H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.594 1.688a8.906 8.906 0 1 0 0 17.812 8.906 8.906 0 0 0 0-17.812m7.719 8.906a7.64 7.64 0 0 1-1.865 5.011L5.583 4.739a7.64 7.64 0 0 1 5.01-1.864 7.73 7.73 0 0 1 7.72 7.719m-15.438 0a7.64 7.64 0 0 1 1.864-5.011l10.866 10.865a7.64 7.64 0 0 1-5.011 1.864 7.73 7.73 0 0 1-7.719-7.718",
    clipRule: "evenodd"
  })));
};
export default SvgRestricted16;